import { Controller } from "@hotwired/stimulus";
import { initializeTooltips } from "../../../../scripts/tooltips";
import "./ProgressBarStep.scss";

export default class ProgressBarStepController extends Controller {
    
    connect() {
        initializeTooltips($(this.element));
    }
}